var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkerAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_91612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 9.65546C18.1745 9.65546 19.6255 8.16908 19.6255 6.32773C19.6255 4.48639 18.1745 3 16.3636 3C14.5527 3 13.0909 4.48639 13.0909 6.32773C13.0909 8.16908 14.5527 9.65546 16.3636 9.65546ZM7.63636 9.65546C9.44727 9.65546 10.8982 8.16908 10.8982 6.32773C10.8982 4.48639 9.44727 3 7.63636 3C5.82545 3 4.36364 4.48639 4.36364 6.32773C4.36364 8.16908 5.82545 9.65546 7.63636 9.65546ZM7.63636 11.8739C5.09455 11.8739 0 13.1718 0 15.7563V18.5294H15.2727V15.7563C15.2727 13.1718 10.1782 11.8739 7.63636 11.8739ZM16.3636 11.8739C16.0473 11.8739 15.6873 11.8961 15.3055 11.9294C16.5709 12.8612 17.4545 14.1146 17.4545 15.7563V18.5294H24V15.7563C24 13.1718 18.9055 11.8739 16.3636 11.8739Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_91612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkerAll);
export default __webpack_public_path__ + "static/media/icon-worker-all.39147a585d483ebdfe4dd7c2d0f99d42.svg";
export { ForwardRef as ReactComponent };